import { 
  addMessageToConversation, 
  updateConversation, 
  updateMessageStatus, 
  upsertConversation, 
  fetchConversationRequest 
} from '../../store/conversationSlice';
import { transformMessage, transformConversation } from '../../components/whatsapp/chat/conversationTransform';
import { playNotificationSound } from '../../utils/notification';

export const getPayloadProcessor = (dispatch) => (payload) => {
  const { type, data } = payload;


  if (!type && payload.message && (payload.connectionId || payload.requestId)) {
    return;
  }

  switch (type) {
    case 'NEW_MESSAGE': {
      try {
        const formattedMessage = transformMessage(data);
        dispatch(addMessageToConversation(formattedMessage));
        playNotificationSound();
      } catch (transformError) {
      }
      break;
    }
    
    case 'CONVERSATION_CREATED': {
      try {
        const formattedConversation = transformConversation(data, []);
        dispatch(upsertConversation(formattedConversation));
      } catch (error) {
      }
      break;
    }
    
    case 'MESSAGE_STATUS_UPDATE': {
      const { conversationId, messageId, status } = data;
      if (conversationId && messageId) {
        dispatch(updateMessageStatus({ conversationId, messageId, status }));
      } else {
      }
      break;
    }

    case 'CONVERSATION_ASSIGNED':
    case 'CONVERSATION_UPDATED':
    case 'CONVERSATION_CLOSED': {
      const { conversationId, assignedAgentId, status } = data;
      if (conversationId) {
        const updates = {};
        if (assignedAgentId !== undefined) updates.assignedAgentId = assignedAgentId;
        if (status !== undefined) updates.status = status;
        
        if (Object.keys(updates).length > 0) {
          dispatch(updateConversation({ id: conversationId, updates }));
        }
      }
      break;
    }

    case 'MEDIA_READY': {
      if (data?.conversationId) {
          dispatch(
            fetchConversationRequest({
              conversationId: data.conversationId,
              background: true,
            })
          );
      }
      break;
    }

    default:
      break;
  }
};
